<template>
  <b-container fluid>
    <b-row>
      <b-col cols="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">Import settings</h4>
          </template>
          <template v-slot:body>
            <b-row class="mb-4">
              <b-col>
                <b-form-group label="Import name">
                  <b-form-input type="text" v-model="name" size="sm" />
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Create list">
                  <b-form-select
                    plain
                    v-model="createList"
                    :options="createListOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="List name">
                  <b-form-input
                    type="text"
                    v-model="listName"
                    size="sm"
                    :disabled="createList == false"
                  />
                </b-form-group>
              </b-col>
              <!-- <b-col>
                <b-form-group label="Delimiter">
                  <b-form-select
                    plain
                    v-model="delimiter"
                    :options="delimiterOptions"
                    size="sm"
                  >
                  </b-form-select>
                </b-form-group>
              </b-col>-->
            </b-row>
            <b-row>
              <b-col>
                 <b-form-group label="Consent">
                  <b-form-select
                    plain
                    required
                    v-model="consent"
                    :options="consentOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
                <b-col>
                  <b-alert :show="true" variant="primary" class="bg-white">
                    <div class="iq-info-text">
                      <p class="mb-0">
                        {{consentMessage}}
                      </p>
                    </div>
                  </b-alert>
                </b-col>
            </b-row>
            <b-row class="mb-4">
              <b-col>
                <h4>Dataset</h4>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <p>upload *.CSV file in defined form here</p>
                <b-form-group label-for="customFile">
                  <b-form-file
                    placeholder="Choose a file"
                    @change="fileChangeHandler"
                    id="customFile"
                    data-cy="import-csv-select-file"
                  ></b-form-file>
                </b-form-group>
                <p>or copy & paste CSV text below</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form>
                  <b-form-group label-for="exampleFormControlTextarea1">
                    <b-form-textarea
                      id="exampleFormControlTextarea1"
                      rows="10"
                      v-model="csvData"
                      wrap="off"
                    ></b-form-textarea>
                  </b-form-group>
                </b-form>
                <b-alert
                  :show="parsingResult.errors.length > 0 ? true : false"
                  variant="danger"
                >
                  <div class="iq-alert-text">
                    CSV contains {{ parsingResult.errors.length }} errors. You
                    need to fix them to upload data.
                  </div>
                </b-alert>
                <b-alert :show="isUploadable" variant="success">
                  <div class="iq-alert-text">CSV is ok.</div>
                </b-alert>
              </b-col>
              <b-col cols="3" v-if="parsingResult.errors.length > 0">
                <h5>
                  Please fix these {{ parsingResult.errors.length }} errors
                </h5>
                <div style="max-height: 400px; overflow-y: scroll">
                  <ul>
                    <li v-for="error in parsingResult.errors" :key="error.text">
                      {{ error.text }}
                    </li>
                  </ul>
                </div>
              </b-col>
            </b-row>
            <div v-if="parsingResult.sampleRecords.length > 0" class="mt-4">
              <b-row class="mb-4">
                <b-col>
                  <h4 class="card-title">Preview</h4>
                </b-col>
              </b-row>
              <b-row>
                <b-col style="overflow: scroll">
                  <b-table :items="parsingResult.sampleRecords"></b-table>
                </b-col>
              </b-row>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button
          block
          variant="primary"
          class="mb-3 mr-1"
          @click="submitHandler"
          :disabled="!isUploadable"
          data-cy="import-csv-button"
          >Import CSV</b-button
        >
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from "../../config/pluginInit";
import gql from "graphql-tag";
const CREATE_IMPORT = gql`
  mutation createImport(
    $name: String!
    $createList: Boolean!
    $listName: String
    $delimiter: String!
    $data: String!
    $consent: consent_enum_enum!
  ) {
    insert_data_imports_one(
      object: {
        list_name: $listName
        delimiter: $delimiter
        data: $data
        create_list: $createList
        name: $name
        consent: $consent
      }
    ) {
      id
    }
  }
`;
const LIST_CONSENT_ENUM = gql`
  query {
    consent_enum {
      value
      description
    }
  }
`
export default {
  name: "ImportsCreate",
  mounted() {
    core.index();
  },
  data() {
    return {
      name: `import-${new Date().toISOString().substring(0, 19)}`,
      consent: "",
      csvData: "",
      rawCSVData: "",
      delimiter: ",",
      createList: true,
      listName: "imported-" + new Date().toISOString().substring(0, 19),
      requiredColumns: [
        "company_sync_id",
        "company_name",
        "contact_first_name",
        "contact_last_name",
        "contact_email",
        "contact_title",
        "company_owner",
        "company_business_potential_total",
        "company_current_billing_monthly",
        "company_business_potential_use_share",
        "company_number_of_used_products"
      ],
      delimiterOptions: [
        { value: ",", text: "," },
        { value: ";", text: ";" }
      ],
      createListOptions: [
        { value: true, text: "update contacts and create new list" },
        { value: false, text: "only update contacts" }
      ],
      parsingResult: {
        numberOfRows: 0,
        columnNames: [],
        sampleRecords: [],
        errors: []
      }
    };
  },
  apollo: {
    consent_enum: {
      query: LIST_CONSENT_ENUM
    }
  },
  computed: {
    missingColumns() {
      const missing = this.requiredColumns.filter(
        rc => this.parsingResult.columnNames.indexOf(rc) === -1
      );
      return missing;
    },
    isUploadable() {
      if (!this.consent || this.consent === 'NO_CONSENT') {
        return false;
      }
      if (this.csvData.length < 1) {
        return false;
      }
      if (!this.delimiter) {
        return false;
      }
      if (this.missingColumns.length > 0) {
        return false;
      }
      if (this.parsingResult.errors.length > 0) {
        return false;
      }
      return true;
    },
    consentOptions(){
      return this.consent_enum?.map(i => ({
        value: i.value,
        text: i.description
      }))
    },
    consentMessage() {
      switch (this.consent) {
        case 'MARKETING':
          return 'Data will be anonymized so that we do not profile individuals (contacts), but only the companies where the contacts are employed.'
        case 'PROFILING':
          return `Full import from specified csv without any restrictions.`
        case 'OUTSIDE_EU':
          return `Full import from specified csv without any restrictions.`
        case 'NO_CONSENT':
          return `Sorry, but we can't import the data because it would be a violation of the law.`
        default:
          return 'As the person responsible for the administration of your organisation, select the type of informed consent you have from your end customers / companies for all imported contacts.'
      }
    }
  },
  methods: {
    fileChangeHandler(e) {
      var input = e.target;

      const setCSVData = data => {
        this.csvData = data;
      };
      var reader = new FileReader();
      reader.onload = function() {
        setCSVData(reader.result);
      };
      reader.readAsText(input.files[0]); // NOTE: there should be readAsBinaryString but that is not supported by IE

      // // do the same but for raw data
      // const setRawCSVData = data => {
      //   this.rawCSVData = data;
      // };
      // var rawReader = new FileReader();
      // rawReader.onload = function() {
      //   setRawCSVData(
      //     rawReader.result.slice(rawReader.result.indexOf(",") + 1)
      //   );
      // };
      // rawReader.readAsDataURL(input.files[0]);
    },
    parseCSVLine(str) {
      var arr = [];
      var quote = false; // 'true' means we're inside a quoted field

      // Iterate over each character, keep track of current row and column (of the returned array)
      for (var row = 0, col = 0, c = 0; c < str.length; c++) {
        var cc = str[c],
          nc = str[c + 1]; // Current character, next character
        arr[row] = arr[row] || []; // Create a new row if necessary
        arr[row][col] = arr[row][col] || ""; // Create a new column (start with empty string) if necessary

        // If the current character is a quotation mark, and we're inside a
        // quoted field, and the next character is also a quotation mark,
        // add a quotation mark to the current column and skip the next character
        if (cc == '"' && quote && nc == '"') {
          arr[row][col] += cc;
          ++c;
          continue;
        }

        // If it's just one quotation mark, begin/end quoted field
        if (cc == '"') {
          quote = !quote;
          continue;
        }

        // If it's a comma and we're not in a quoted field, move on to the next column
        if (cc == "," && !quote) {
          ++col;
          continue;
        }

        // If it's a newline (CRLF) and we're not in a quoted field, skip the next character
        // and move on to the next row and move to column 0 of that new row
        if (cc == "\r" && nc == "\n" && !quote) {
          ++row;
          col = 0;
          ++c;
          continue;
        }

        // If it's a newline (LF or CR) and we're not in a quoted field,
        // move on to the next row and move to column 0 of that new row
        if (cc == "\n" && !quote) {
          ++row;
          col = 0;
          continue;
        }
        if (cc == "\r" && !quote) {
          ++row;
          col = 0;
          continue;
        }

        // Otherwise, append the current character to the current column
        arr[row][col] += cc;
      }
      return arr;
    },
    parseCSVData(sourceStr) {
      const sampleSize = 5;
      const delimiter = this.delimiter;
      const status = {
        numberOfRows: 0,
        columnNames: [],
        sampleRecords: [],
        errors: []
      };

      // parse lines
      let lines = sourceStr.split("\n");
      if (lines.length < 2) {
        return {
          ...status,
          errors: [{ text: "there is no data" }]
        };
      }

      // parse header
      const columnNames = lines[0].split(delimiter);

      // check for missing columns
      const missingColumns = this.requiredColumns.filter(
        rc => columnNames.indexOf(rc) === -1
      );

      if (missingColumns.length > 0) {
        return {
          ...status,
          errors: missingColumns.map(mc => ({ text: `missing column '${mc}'` }))
        };
      }

      // first line is considered header and check if last not empty
      if (lines[lines.length - 1] === "") {
        lines = lines.slice(1, lines.length - 1);
      } else {
        lines = lines.slice(1, lines.length);
      }

      // index of email column
      const contactEmailColumnIdx = columnNames.indexOf("contact_email");
      if (contactEmailColumnIdx < 0) {
        return {
          ...status,
          errors: [{ text: "there is no 'contact_email' column" }]
        };
      }

      // tokenize every single row and:
      // - check if number of items in row same as columns, otherwise add to errors
      // - add to sample records
      const sampleRecords = [];
      const errors = [];
      const emails = [];
      for (let i = 0; i < lines.length; i++) {
        const lineTokens = this.parseCSVLine(lines[i])?.[0] || [];
        // if not same number of items and header, add to errors
        if (lineTokens.length !== columnNames.length) {
          errors.push({ text: `line ${i + 1}: not same columns as header` });
          continue;
        }

        // check email if already exists - check for dulicities
        const lineEmail = lineTokens[contactEmailColumnIdx];
        if (emails.includes(lineEmail)) {
          errors.push({
            text: `line ${i + 1}: '${lineEmail}' already exists`
          });
          continue;
        } else {
          emails.push(lineEmail);
        }

        // if line valid, add to sampleRecords
        if (sampleRecords.length < sampleSize) {
          const newObject = {};
          for (let j = 0; j < columnNames.length; j++) {
            newObject[columnNames[j]] = lineTokens[j];
          }
          sampleRecords.push(newObject);
        }
      }

      return {
        ...status,
        numberOfRows: lines.length,
        columnNames: columnNames,
        sampleRecords: sampleRecords,
        errors: errors
      };
    },
    async submitHandler() {
      const buff = new Buffer(this.csvData);
      let base64data = buff.toString("base64");

      console.log("base64data", base64data);
      try {
        const res = await this.$apollo.mutate({
          mutation: CREATE_IMPORT,
          variables: {
            name: this.name,
            createList: this.createList,
            listName: this.createList === true ? this.listName : undefined,
            delimiter: this.delimiter,
            data: base64data,
            consent: this.consent,
          }
        });
        this.$toast.success(`Import created`);
        console.log(res);
        const importId = res.data.insert_data_imports_one.id;
        this.$router.push({ path: `/imports/${importId}/detail` });
      } catch (error) {
        this.$toast.error(`Failed to create import: ${error.message}`);
      }
    }
  },
  watch: {
    csvData: function() {
      const res = this.parseCSVData(this.csvData);
      this.parsingResult = res;
    },
    // TODO: this seems redundant
    delimiter: function(value) {
      const res = this.parseCSVData(this.csvData);
      this.parsingResult = res;
    }
  }
};
</script>
<style scoped>
textarea {
  line-height: 2em !important;
}
ul {
  padding-left: 1em !important;
  list-style: circle !important;
}
</style>
